// Minimal WhatsApp brand glyph — lucide-react doesn't ship one.
export function WhatsAppIcon({ className = "h-4 w-4" }) {
    return (
        <svg
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            className={className}
            aria-hidden="true"
        >
            <path d="M20.52 3.48A11.86 11.86 0 0 0 12.05 0C5.5 0 .17 5.34.17 11.9c0 2.1.55 4.15 1.6 5.96L0 24l6.32-1.66a11.87 11.87 0 0 0 5.73 1.46h.01c6.55 0 11.88-5.34 11.88-11.9 0-3.18-1.24-6.17-3.42-8.42Zm-8.47 18.3h-.01a9.86 9.86 0 0 1-5.03-1.38l-.36-.21-3.75.99 1-3.66-.24-.38a9.9 9.9 0 0 1-1.51-5.24c0-5.46 4.44-9.9 9.91-9.9 2.64 0 5.13 1.03 7 2.9a9.83 9.83 0 0 1 2.91 7c0 5.46-4.44 9.88-9.92 9.88Zm5.44-7.4c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15s-.77.96-.94 1.16c-.17.2-.35.22-.65.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.48-1.77-1.65-2.07-.17-.3-.02-.46.13-.6.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.03-.52-.07-.15-.67-1.6-.92-2.19-.24-.58-.49-.5-.67-.5l-.57-.01c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.48s1.07 2.88 1.22 3.08c.15.2 2.1 3.2 5.09 4.49.71.31 1.26.5 1.7.64.71.23 1.36.2 1.87.12.57-.08 1.76-.72 2-1.4.25-.7.25-1.28.17-1.4-.07-.13-.27-.2-.57-.35Z" />
        </svg>
    );
}
